import { isOption, Option } from "api/common/types/common.types";

export const groupByFirstLetter = (option: string | Option) => {
  if (isOption(option)) return option.label[0]?.toUpperCase();
  return option[0]?.toUpperCase();
};
